import React from "react";
import { TabLabel, TabName, TabNameContainer } from "./TabViewStyled";
import { Input } from "antd";
import PropTypes from "prop-types";
import { mimeToExtension, MS_FILE_TYPES, PDF_FILE_TYPES } from "../../utils/constants";
import { getFileIcon } from "../../utils/fileUtils";

const DocumentTabLabel = ({
  tab,
  activeTab,
  renameEditFlag,
  titleName,
  setTitleName,
  updateTitleName,
  renameDocument,
  handleBlur,
}) => {
  const { documentRecord } = tab?.content?.props || {};
  const { unique_id, file_type, name } = documentRecord || {};

  const isFixed = renameEditFlag[unique_id] === false;

  const hasTitleNameEntry = unique_id in titleName;
  const currentTitle = hasTitleNameEntry ? titleName[unique_id] : (tab.title || "");
  const baseName = currentTitle.split(`.`)[0];
  const active = (activeTab === tab.id)?true:false;

  const renderTabName = () => {
    if (isFixed) {
      return (
        <TabNameContainer>
          { PDF_FILE_TYPES.includes(file_type) && getFileIcon(name, file_type,active)}
          { MS_FILE_TYPES.includes(file_type) && getFileIcon(name, file_type,active)}
          <TabName title={tab?.title || "Unknown"}>
            {`${baseName}`}
          </TabName>
        </TabNameContainer>
      );
    }

    return (
      <>
        <Input
          id={unique_id}
          style={{ width: "60%" }}
          onChange={(e) => {
            e.stopPropagation();
            updateTitleName(setTitleName, unique_id, e.target.value, file_type);
          }}
          onKeyDown={(e) => renameDocument(e, unique_id, file_type, documentRecord?.name)}
          placeholder="Rename"
          onBlur={() => handleBlur(documentRecord, true)}
          value={baseName}
          autoFocus
        />
        {`.${mimeToExtension[file_type]}`}
      </>
    );
  };

  return (
    <TabLabel tabactive={activeTab === tab.id ? "true" : ""}>
      {renderTabName()}
    </TabLabel>
  );
};

DocumentTabLabel.propTypes = {
  tab: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    content: PropTypes.shape({
      props: PropTypes.shape({
        documentRecord: PropTypes.shape({
          unique_id: PropTypes.string,
          file_type: PropTypes.string,
          name: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
  activeTab: PropTypes.string.isRequired,
  renameEditFlag: PropTypes.objectOf(PropTypes.bool).isRequired, // e.g., { '123': false, '456': true }
  titleName: PropTypes.objectOf(PropTypes.string).isRequired,    // e.g., { '123': 'doc1.pdf' }
  setTitleName: PropTypes.func.isRequired,
  updateTitleName: PropTypes.func.isRequired,
  renameDocument: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
};

export default DocumentTabLabel;
